import './Tooltip.scss';

import React, { MutableRefObject, ReactNode, ReactNodeArray, RefObject, useEffect } from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';

export interface IProps {
  targetRef: MutableRefObject<any> | RefObject<any>;
  children: string | ReactNode | ReactNodeArray;
  visible?: boolean;
  placement?:
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'left'
    | 'left-start'
    | 'left-end';
  offset?: [number, number];
  forceUpdateRef?: MutableRefObject<() => void>;
}

function Tooltip({
  targetRef,
  children,
  visible: isVisible,
  offset,
  forceUpdateRef,
  placement = 'top',
}: IProps) {
  const { getTooltipProps, getArrowProps, setTooltipRef, setTriggerRef, visible, state, forceUpdate } =
    usePopperTooltip({
      visible: isVisible,
      placement,
      offset,
    });

  useEffect(() => {
    setTriggerRef(targetRef.current);
  });

  useEffect(() => {
    if (forceUpdateRef) {
      forceUpdateRef.current = forceUpdate;
    }
  }, [forceUpdate]);

  if (!visible) {
    return null;
  }
  return (
    <div ref={setTooltipRef} {...getTooltipProps({ className: 'novoTooltip' })}>
      <div
        {...getArrowProps({
          className: `novoTooltip__arrow novoTooltip__arrow--${state?.placement.split('-')[0]}`,
        })}
      />
      <div className="novoTooltip__content">{children}</div>
    </div>
  );
}

export default Tooltip;
